<template>
	<div class="iq-network-details">

		<div class="clearfix">
			<h2>Network info</h2>
			<div class="sub-grid-buttons">
				<a @click="refresh()" class="btn btn-light btn-sm">Refresh</a>
			</div>
		</div>

		<div v-if="isLoading" class="clearfix"><span class="spinner anim-spin"></span> Loading...</div>

		<div v-if="!isLoading && iq">

			<table class="table">

				<tbody>
					<tr class="iq__rf-info">
						<td><label>RF channel: </label></td>
						<td colspan="3">
							<strong :title="'Last check: ' + iq.rf_last_update">{{iq.rf_channel}}</strong>
						</td>
					</tr>

					<tr class="iq__network-adapter" v-for="adapter in iq.network_adapters">
						<td><label>{{adapter.type}}</label></td>
						<td>
							<span class="text-success" v-if="adapter.status === 'active'"><i class="fa fa-circle"></i> active</span>
							<span class="text-secondary" v-if="adapter.status !== 'active'"><i class="fa fa-circle"></i> {{adapter.status}}</span>
						</td>
						<td>
							<div v-if="adapter.priority !== null">
								<small>Priority</small><br />
								<div>#{{adapter.priority}}</div>
							</div>
							<div class="text-secondary" v-if="adapter.priority === null">
								No priority
							</div>
						</td>
						<td>
							<small>MAC Address</small><br />
							<span v-if="adapter.mac_address">{{adapter.mac_address}}</span>
							<span v-if="!adapter.mac_address" class="text-secondary">Unavailable</span>
						</td>
					</tr>
				</tbody>

			</table>
		</div>

	</div>
</template>
<style scoped>
	.text-secondary {
		color: #999;
	}
	.iq__rf-info td {
		border-top: none !important;
	}
	.table td {
		padding-left: 0;
	}
	.iq-network-details {
		margin: 35px 0;
		max-width: 500px;
	}
</style>
<script>
import Hardware from "../Services/Hardware";

export default {

		props: ['iqId'],

		data: () => { return {
			isLoading: true,
			iq: null,
		}},

		mounted() {
			this.refresh();
		},

		methods: {

			refresh() {
				this.isLoading = true;

				Hardware.getIQNetworkDetails(this.iqId)
					.then((iq) => {
						this.iq = iq;
						this.isLoading = false;
					})
					.catch((err) => {
						this.isLoading = false;
					});
			}

		}

	}
</script>
